export default __webpack_public_path__ + "static/media/five.972ce7a2.svg";